const initialState = {
  	menu_open_state: [],
    logined: false,
    open: true,
    rainfall_data: ['rainfall data']
};

export function reducer(state = initialState, action) {
  	console.log('reducer', state, action)
  	switch (action.type) {
  		//case 'open_menu':
  		//	console.log("toggole menu with id: "+action.id)
  		//	return state.menu_open_state.map((menu)=>{
  		//		if (action.id === menu.id) {
  		//			return Object.assign({}, menu, {
			//            open: !menu.completed
			//        })
  		//		} else {
  		//			return menu
  		//		}
  		//	})
  		//case 'add_menu':
  		//	console.log("add menu with id: "+action.id)
  		//	return [
		  //    ...state,
		  //    {
		  //      id: action.id,
		  //      open: false
		  //    }
		  //  ]
      case 'log_in':
        console.log("log in")
        return {
          ...state,
          logined: true
      }
      case 'log_out':
        console.log("log out")
        return {
          ...state,
          logined: false
      }
      case 'draw_control':
        return {
          ...state,
          open: action.open
      }
      case 'rainfallupdate':
        return {
            ...state,
            rainfall_data: action.data
      }
  		default:
  			console.log("unknow action")
  			return state
  	}

}



// WEBPACK FOOTER //
// ./src/redux/reducers.js